export default __webpack_public_path__ + "static/media/imagenconvocaagenda.c4ef965d.jpeg";